import { parsePhoneNumberFromString, CountryCode, PhoneNumber } from 'libphonenumber-js/core';

import metadata from './metadata';
import NumberTypes from '../constants/NumberTypes';

type TPhoneValidation = {
  isCorrectCountry: boolean;
  isMobile: boolean;
  isPaidNumber: boolean;
  isValid: boolean;
  parsedPhoneNumber?: PhoneNumber;
};

export default (input: string, countryCode: CountryCode): TPhoneValidation => {
  const parsedPhoneNumber = parsePhoneNumberFromString(input, countryCode, metadata);

  if (!parsedPhoneNumber) {
    return {
      isCorrectCountry: false,
      isMobile: false,
      isPaidNumber: false,
      isValid: false,
    };
  }
  return {
    parsedPhoneNumber,
    isCorrectCountry: parsedPhoneNumber.country === countryCode,
    isMobile: parsedPhoneNumber.getType() === NumberTypes.MOBILE,
    isPaidNumber: parsedPhoneNumber.getType() === NumberTypes.PREMIUM_RATE,
    isValid: parsedPhoneNumber.isValid(),
  };
};
